import React, { useState } from "react";
import { Checkbox, FormControlLabel, Box } from "@mui/material";
import FilterAccordion from "./FilterAccordion";
import {
  ALL_SENTIMENTS,
  SENTIMENT_OPTIONS,
  channelHelperText,
} from "../Inbox/Utilities/inboxUtils";

export default function SentimentFilter({ selected, onChange }) {
  const [localSelected, setLocalSelected] = useState(ALL_SENTIMENTS);
  const active = selected ?? localSelected;
  const labels = SENTIMENT_OPTIONS.filter((option) =>
    active.includes(option.value),
  ).map((option) => option.label);

  const toggle = (value) => {
    const next = active.includes(value)
      ? active.filter((item) => item !== value)
      : [...active, value];
    if (onChange) {
      onChange(next);
      return;
    }
    setLocalSelected(next);
  };

  const helperText = channelHelperText(
    SENTIMENT_OPTIONS.map((option) => ({ label: option.label })),
    labels,
  );

  return (
    <FilterAccordion label="Sentiment" helperText={helperText}>
      {SENTIMENT_OPTIONS.map((option) => (
        <FormControlLabel
          key={option.value}
          sx={styles.formControl}
          label={<SentimentLabel label={option.label} color={option.color} />}
          labelPlacement="start"
          control={
            <Checkbox
              checked={active.includes(option.value)}
              onChange={() => toggle(option.value)}
              sx={styles.checkbox}
            />
          }
        />
      ))}
    </FilterAccordion>
  );
}

const SentimentLabel = ({ label, color }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <Box
        sx={{
          backgroundColor: color,
          width: "9px",
          height: "9px",
          borderRadius: "999px",
        }}
      ></Box>
      {label}
    </Box>
  );
};

const styles = {
  formControl: {
    "& .MuiFormControlLabel-label": {
      fontSize: "0.8125rem",
      fontFamily: "FustatMedium",
      color: "#33413a",
    },
    width: "100%",
    margin: 0,
    justifyContent: "space-between",
  },
  checkbox: {
    color: "#aeaeae",
    "&.Mui-checked": {
      color: "#003300",
    },
  },
};
